module.exports = __webpack_public_path__ + "static/media/tn.75753d15.png";